import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CommonService } from '../../../../services/common/common.service';
import { ApplicationsDataService, ApplicationsColumnsService, CategoriesDataService } from '../../../services';
import { Application, ApplicationsResult, CategoriesResult } from '../../../interfaces';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
import { DialogFilerComponent } from '../../filer/filer.component';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-post-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig, DialogService],
})
export class ApplicationFormComponent implements OnInit {

  public application: Application = {};
  public applicationForm: FormGroup = new FormGroup({});
  public applications: Application[] = [];
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public categories:any;
  selectedFile: File | null;

  public Editor = ClassicEditor;
  categoryValue: any;
  formData = new FormData();
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private messageService: MessageService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private applicationsDataService: ApplicationsDataService,
    public applicationsColumnsService: ApplicationsColumnsService,
    public editorService: EditorService,
    public categoriesDataService: CategoriesDataService,
    private dialogService: DialogService,

  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null
  }

  ngOnInit(): void {
    this.getCategories();
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.application = this.dynamicDialogConfig.data.post;
    }
  if (typeof this.application.id === 'undefined' || this.application.id === null) {
      this.application.id = null;
      this.application.isActive = false;
  }
    
    this.getApplications();
    this.prepareFrom();
  }


  getCategories(){
    this.categoriesDataService.getCategories().subscribe((response: CategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.categories = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }

  getApplications(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.posts !== 'undefined' && this.dynamicDialogConfig.data.posts.length > 0) {
      this.applications = this.dynamicDialogConfig.data.posts;
      return;
    }
    this.applicationsDataService.getApplications().subscribe((response: ApplicationsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.applications = response.success.data;
      }
    });
  }

  prepareFrom(): void {
    this.applicationForm = new FormGroup({
      id: new FormControl(this.application.id, []),
      name: new FormControl(this.application.name, []),
      logoLeft: new FormControl(this.application.logoLeft, []),
      logoRight: new FormControl(this.application.logoRight, []),

      description: new FormControl(this.application.description, []),
      background: new FormControl(this.application.background, []),
      primaryColor: new FormControl(this.application.primaryColor, []),
      tabBar: new FormControl(this.application.tabBar, []),
      secondaryColor: new FormControl(this.application.secondaryColor, []),
      activityStyleNotFocused: new FormControl(this.application.activityStyleNotFocused, []),
      tabIconNotFocused: new FormControl(this.application.tabIconNotFocused, []),
      objectifBackgroundColor: new FormControl(this.application.objectifBackgroundColor, []),
      addRemoveObjectifColor: new FormControl(this.application.addRemoveObjectifColor, []),
      progressBackgroundColor: new FormControl(this.application.progressBackgroundColor, []),
      activeGoalProgresseColor: new FormControl(this.application.activeGoalProgresseColor, []),
      tabIconFocused: new FormControl(this.application.tabIconFocused, []),

      progressValueColor: new FormControl(this.application.progressValueColor, []),
      profileColor: new FormControl(this.application.profileColor, []),
      ajourdHisto: new FormControl(this.application.ajourdHisto, []),
      offreId: new FormControl(this.application.offreId, []),
      thirdColor: new FormControl(this.application.thirdColor, []),
      fourthColor: new FormControl(this.application.fourthColor, []),
      icStepColor: new FormControl(this.application.icStepColor, []),
      icCollectedPointColor: new FormControl(this.application.icCollectedPointColor, []),
      icDurationColor: new FormControl(this.application.icDurationColor, []),
      icPositionColor: new FormControl(this.application.icPositionColor, []),
      backgroundColorPrimary: new FormControl(this.application.backgroundColorPrimary, []),
      backgroundColorSecondary: new FormControl(this.application.backgroundColorSecondary, []),
      buttonColorPrimary: new FormControl(this.application.buttonColorPrimary, []),
      buttonColorSecondary: new FormControl(this.application.buttonColorSecondary, []),
      placeholderText: new FormControl(this.application.placeholderText, []),
      categoryColor: new FormControl(this.application.categoryColor, []),
      inputColor: new FormControl(this.application.inputColor, []),
      blogDetail: new FormControl(this.application.blogDetail, []),
      textProfile: new FormControl(this.application.textProfile, []),
      profileInputs: new FormControl(this.application.profileInputs, []),
      splashScreen: new FormControl(this.application.splashScreen, []),
      logoProfile: new FormControl(this.application.logoProfile, []),
      logoApp: new FormControl(this.application.logoApp, []),
      progressValuePrimary: new FormControl(this.application.progressValuePrimary, []),
      progressValueSecondary: new FormControl(this.application.progressValueSecondary, []),
      resetModeId: new FormControl(this.application.resetModeId, []),
      imgGrad: new FormControl(this.application.imgGrad, []),
      imgBorderPrimary: new FormControl(this.application.imgBorderPrimary, []),
      imgBorderSecondary: new FormControl(this.application.imgBorderSecondary, []),
      textBg: new FormControl(this.application.textBg, []),
     
    });
  }

  onChange(e:any) {
    this.categoryValue = e.value;
  }

  list() {
    this.router.navigate(['/posts']);
  }

  showErrors() {
      const invalidFields: string[] = [];
      Object.keys(this.applicationForm.controls).forEach((field: any) => {
        const control = this.applicationForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.applicationForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.application = this.applicationForm.value;
    this.disableSubmit = true;
    this.formData.append('name', this.applicationForm ? this.applicationForm.value.name : null);
    this.formData.append('description', this.applicationForm ? this.applicationForm.value.description : null);
    this.formData.append('logoLeft', this.applicationForm ? this.applicationForm.value.logoLeft : null);
    this.formData.append('logoRight', this.applicationForm ? this.applicationForm.value.logoRight : null);
    this.formData.append('background', this.applicationForm ? this.applicationForm.value.background : null);

    this.formData.append('primaryColor', this.applicationForm ? this.applicationForm.value.primaryColor : null);
    this.formData.append('activityStyle', this.applicationForm ? this.applicationForm.value.primaryColor : null);
    this.formData.append('addRemoveObjectifColor', this.applicationForm ? this.applicationForm.value.primaryColor : null);
    this.formData.append('activeGoalProgresseColor', this.applicationForm ? this.applicationForm.value.primaryColor : null);
    this.formData.append('description', this.applicationForm ? this.applicationForm.value.primaryColor : null);
    this.formData.append('ajourdHisto', this.applicationForm ? this.applicationForm.value.primaryColor : null);



    this.formData.append('secondaryColor', this.applicationForm ? this.applicationForm.value.secondaryColor : null);
    this.formData.append('tabBar', this.applicationForm ? this.applicationForm.value.tabBar : null);

    this.formData.append('activityStyleNotFocused', this.applicationForm ? this.applicationForm.value.activityStyleNotFocused : null);
    this.formData.append('objectifBackgroundColor', this.applicationForm ? this.applicationForm.value.objectifBackgroundColor : null);
    this.formData.append('progressBackgroundColor', this.applicationForm ? this.applicationForm.value.progressBackgroundColor : null);
    this.formData.append('progressValueColor', this.applicationForm ? this.applicationForm.value.progressValueColor : null);
    this.formData.append('profileColor', this.applicationForm ? this.applicationForm.value.profileColor : null);
    this.formData.append('tabIconNotFocused', this.applicationForm ? this.applicationForm.value.tabIconNotFocused : null);
    this.formData.append('tabIconFocused', this.applicationForm ? this.applicationForm.value.tabIconFocused : null);
    this.formData.append('offreId', this.applicationForm ? this.applicationForm.value.offreId : null);
    this.formData.append('offreId', this.applicationForm ? this.applicationForm.value.offreId : null);

    this.formData.append('thirdColor', this.applicationForm ? this.applicationForm.value.thirdColor : null);
    this.formData.append('fourthColor', this.applicationForm ? this.applicationForm.value.fourthColor : null);
    this.formData.append('icStepColor', this.applicationForm ? this.applicationForm.value.icStepColor : null);
    this.formData.append('icCollectedPointColor', this.applicationForm ? this.applicationForm.value.icCollectedPointColor : null);
    this.formData.append('icDurationColor', this.applicationForm ? this.applicationForm.value.icDurationColor : null);
    this.formData.append('icPositionColor', this.applicationForm ? this.applicationForm.value.icPositionColor : null);
    this.formData.append('backgroundColorPrimary', this.applicationForm ? this.applicationForm.value.backgroundColorPrimary : null);
    this.formData.append('backgroundColorSecondary', this.applicationForm ? this.applicationForm.value.backgroundColorSecondary : null);
    this.formData.append('buttonColorPrimary', this.applicationForm ? this.applicationForm.value.buttonColorPrimary : null);
    this.formData.append('buttonColorSecondary', this.applicationForm ? this.applicationForm.value.buttonColorSecondary : null);
    this.formData.append('placeholderText', this.applicationForm ? this.applicationForm.value.placeholderText : null);
    this.formData.append('categoryColor', this.applicationForm ? this.applicationForm.value.categoryColor : null);
    this.formData.append('inputColor', this.applicationForm ? this.applicationForm.value.inputColor : null);
    this.formData.append('blogDetail', this.applicationForm ? this.applicationForm.value.blogDetail : null);
    this.formData.append('textProfile', this.applicationForm ? this.applicationForm.value.textProfile : null);
    this.formData.append('profileInputs', this.applicationForm ? this.applicationForm.value.profileInputs : null);
    this.formData.append('splashScreen', this.applicationForm ? this.applicationForm.value.splashScreen : null);
    this.formData.append('logoProfile', this.applicationForm ? this.applicationForm.value.logoProfile : null);
    this.formData.append('logoApp', this.applicationForm ? this.applicationForm.value.logoApp : null);
    this.formData.append('progressValuePrimary', this.applicationForm ? this.applicationForm.value.progressValuePrimary : null);
    this.formData.append('progressValueSecondary', this.applicationForm ? this.applicationForm.value.progressValueSecondary : null);
    this.formData.append('resetModeId', this.applicationForm ? this.applicationForm.value.resetModeId : null);
    this.formData.append('imgGrad', this.applicationForm ? this.applicationForm.value.imgGrad : null);
    this.formData.append('imgBorderPrimary', this.applicationForm ? this.applicationForm.value.imgBorderPrimary : null);
    this.formData.append('imgBorderSecondary', this.applicationForm ? this.applicationForm.value.imgBorderSecondary : null);
    this.formData.append('textBg', this.applicationForm ? this.applicationForm.value.textBg : null);
    

   
    if (this.application.id === null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  update(redirect: boolean) {
    this.applicationsDataService.updateApplication(this.formData, this.applicationForm.value.id).subscribe((data: any) => {
      this.disableSubmit = false;
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      console.warn(error);
    });
  }

  add(redirect: boolean) {
    this.applicationsDataService.addApplication(this.formData).subscribe((data: any) => {
        this.disableSubmit = false;
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        console.warn(error);
    });
  }

  uploadLogoLeft(event: any): void {
    console.log('event',  event.target.files[0])
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('logoLeft', this.selectedFile);
    }
  }
  uploadLogoRight(event: any): void {
    console.log('event',  event.target.files[0])
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('logoRight', this.selectedFile);
    }
  }

  uploadBackground(event: any): void {
    console.log('event',  event.target.files[0])
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('background', this.selectedFile);
    }
  }
  setColor(event: any) {
    const control = this.applicationForm.get('tabBar');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  setColorActivityStyleNotFocused(event: any) {
    const control = this.applicationForm.get('activityStyleNotFocused');
    if (control !== null) {
      console.log('control', event.value)

      control.setValue(event.value);
    }
  }
  setColorTabIconNotFocused(event: any) {
    const control = this.applicationForm.get('tabIconNotFocused');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorTabIconFocused(event: any) {
    const control = this.applicationForm.get('tabIconFocused');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorAddRemoveObjectifColor(event: any) {
    const control = this.applicationForm.get('addRemoveObjectifColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorObjectifBackgroundColor(event: any) {
    const control = this.applicationForm.get('objectifBackgroundColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorProgressBackgroundColor(event: any) {
    const control = this.applicationForm.get('progressBackgroundColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorActiveGoalProgresseColor(event: any) {
    const control = this.applicationForm.get('activeGoalProgresseColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorProgressValueColor(event: any) {
    const control = this.applicationForm.get('progressValueColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorAjourdhisto(event: any) {
    const control = this.applicationForm.get('ajourdHisto');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  
  setColorProfileColor(event: any) {
    const control = this.applicationForm.get('profileColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }
  openFilerDialog(field: string): void {
    let url = '';
    const control = this.applicationForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'applications',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.applicationForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }
}

@Component({
  selector: 'app-post-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogApplicationFormComponent extends ApplicationFormComponent {
}

